(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-collection-listing"] && !window.DesignMode) return;
  try {
    
  $.ajax({
    url: '/collections/color?view=color-pictures.json',
    headers: {
        'Content-Type':'application/json'
    },
    method: 'GET',
    success: function(data){
      var colors_swatches = document.getElementsByClassName("product-card-colors__img");
      const colorUrls = JSON.parse(data);
      for (var i = 0; i < colors_swatches.length; i++) {
        colors_swatches[i].style = "background-image:url(" + colorUrls[colors_swatches[i].title] + ")";
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-homepage-slider"]) return;
  try {
    
  $('.full-width-slider').slick({
    arrows: false,
    dots: true,
    fade: true,
    infinite: true,
    pauseOnHover: false,
    autoplay: true,
    autoplaySpeed: 8000,
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-horizontal-scroll-products"] && !window.DesignMode) return;
  try {
    
  $.ajax({
    url: '/collections/color?view=color-pictures.json',
    headers: {
        'Content-Type':'application/json'
    },
    method: 'GET',
    success: function(data){
      var colors_swatches = document.getElementsByClassName("product-card-colors__img");
      const colorUrls = JSON.parse(data);
      for (var i = 0; i < colors_swatches.length; i++) {
        colors_swatches[i].style = "background-image:url(" + colorUrls[colors_swatches[i].title] + ")";
      }
    }
  });

  } catch(e) { console.error(e); }
})();
})();
